import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: "e739faae-0aa8-486c-95a4-c4ed888582de",
        authority: "https://login.microsoftonline.com/dd7ed090-c589-441a-a4db-24361e4bfccb",
        redirectUri: process.env.NODE_ENV === 'development' ? "http://localhost:3000" : "https://justinkilroy.nyx.baby"
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) { return; }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Verbose,
        }
    }
};

const loginRequest = {
    scopes: ["User.Read"],
};

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance, loginRequest };
